module.exports = __webpack_public_path__ + "img/Hip-Opener-Pomodoro.6a232ab4.jpg";